import {Component, Input, OnInit} from '@angular/core';
import {TeacherBookRestServiceV3} from 'src/app/services/rest/v3/teacher-book-rest-v3.service';
import {combineLatest} from 'rxjs';
import {CalendarEntry} from '../../calendar/week-calendar/week-calendar.component';
import {map, tap} from 'rxjs/operators';
import {V3SimpleProductAvailability, V3TeacherColLessonScheduleEvents} from '../../../model/v3/booking';
import {Dates} from '../../../services/utils/calendar-utils';

@Component({
    selector: 'app-teacher-main-calendar',
    templateUrl: './teacher-main-calendar.component.html',
    styleUrls: ['./teacher-main-calendar.component.css'],
    standalone: false
})
export class TeacherMainCalendarComponent implements OnInit {

  _teacherId: number;
  _focusDate: Date;
  calendarEntries: CalendarEntry[] = [];

  loading = true;

  constructor(
    private bookingRest: TeacherBookRestServiceV3) {
  }

  @Input()
  schoolId: number;

  @Input()
  set teacherId(teacherId: number) {
    this._teacherId = teacherId;
    this.loadWeekEvents();
  }

  set focusDate(date: Date) {
    this._focusDate = date;
    this.loadWeekEvents();
  }

  loadWeekEvents() {
    if (!this._teacherId || !this._focusDate) { return; }
    const weekStart = Dates.getWeekStartDate(this._focusDate);
    const weekEnd = new Date(weekStart.getTime() + 7 * 24 * 60 * 60 * 1000);
    this.loading = true;
    combineLatest([
      this.bookingRest.getAvailabilityEvents(this.schoolId, this._teacherId, weekStart, weekEnd, null)
      .pipe(
        map( worktimesArray => this.mapSimpleProductAvailabilityToCalendarEntry(worktimesArray))
        )
      ,
      this.bookingRest.getTeacherColLessonEvents(this.schoolId, this._teacherId, weekStart, weekEnd)
      .pipe(
        map((schedulesArray) =>
          this.mapSimpleScheduleEventsToCalendarEntry(schedulesArray)
        )
      )]
    ).pipe(
      map(([worktimeEntries , scheduleEntries]) => worktimeEntries.concat(scheduleEntries)),
      tap<CalendarEntry[]>(calendarEntries => this.calendarEntries = calendarEntries)
      )
    .subscribe( () => this.loading = false, () => this.loading = false);
  }

  getAvailabilityName(av: V3SimpleProductAvailability) {
    return `${av.details.product.code}[${av.details.competences.map(c => c.code).join(", ")}]`
  }

  mapSimpleProductAvailabilityToCalendarEntry(schedules: V3SimpleProductAvailability[]): CalendarEntry[] {
    let entries = new Array<CalendarEntry>()
    schedules.forEach(schedule => schedule.events.forEach(ev => {
      const dateTo = new Date();
      dateTo.setTime(ev.eventDate.getTime() + ev.duration);
      let entry = new CalendarEntry(
        schedule.schedule.id,
        ev.eventId,
        ev.eventDate,
        dateTo,
        () => this.getAvailabilityName(schedule),
        null,
        schedule,
        'worktime'
      )
      if(schedules.length > 1)
        entry = entry.narrowIntersected()

      entries.push(entry);
    }))
    return entries
  }

  mapSimpleScheduleEventsToCalendarEntry(schedules: V3TeacherColLessonScheduleEvents[]): CalendarEntry[] {
    let entries = new Array<CalendarEntry>()
    schedules.forEach(schedule => schedule.events.forEach(ev => {
      const dateTo = new Date();
      dateTo.setTime(ev.eventDate.getTime() + ev.duration);
      let entry = new CalendarEntry(
        schedule.schedule.id,
        ev.eventId,
        ev.eventDate,
        dateTo,
        () => schedule.schedule.name,
        null,
        schedule,
        'schedule'
      )
      entries.push(entry);
    }))
    return entries
  }
  ngOnInit() {
  }

}
